<div class="pageContent bodyBg py-3">
  <div class="col-md-12 py-2">
    <div class="title-md text-primary headersize">
      Publications
    </div>
  </div>
  <div class="row">
    <div class="col-md-8 col-lg-9">

      <div class="card py-2 mb-3">
        <div class="defaultTabs">
          <div class="container-fluid">
            <div class="row">
              <div class="col-md-12">

                <div class="row">
                  <div class="col-md-12">
                    <form [formGroup]="PublicationForm">
                      <div class="row">
                        <div class="col-md-4 col-sm-6" *ngIf="displayTPAsearchvalues">
                          <div class="form-group">
                            <label class="fieldLabel">Therapeutic Area</label>
                            <select class="form-control" id="therapeutic-areas" formControlName="Therapeutic_Area_Name"
                              (change)="updateProdList($event)">
                              <option value="">-Select-</option>
                              <option *ngFor="let area of taDisplayList" value="{{area.Therapeutic_Area_Id}}">
                                {{area.Therapeutic_Area_Name}}</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-md-4 col-sm-6" *ngIf="displayPRODsearchvalues">
                          <div class="form-group">
                            <label class="fieldLabel">Product</label>
                            <select class="form-control" id="product_name" formControlName="Product_Name"
                              (change)="updateTheraList($event)">
                              <option value="">-Select-</option>
                              <option *ngFor="let Product of prodDisplayList" value="{{Product.Product_Id}}">
                                {{Product.Product_Name}}</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-md-4 col-sm-6" *ngIf="displayCatsearchvalues">
                          <!--  *ngIf="displayCatsearchvalues" -->
                          <div class="form-group">
                            <label class="fieldLabel ">Category</label>
                            <select class="form-control" id="product_name" formControlName="Category_Name">
                              <option value="">-Select-</option>
                              <option *ngFor="let Category of catList" value="{{Category.Category_Id}}">
                                {{Category.Category_Name}}</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-md-4 col-sm-6" *ngIf="displayPTsearchvalues">
                          <div class="form-group">
                            <label class="fieldLabel ">Publication Title</label>
                            <input type="text" class="form-control" id="PublicationTitle"
                              formControlName="Publication_Title" autocomplete="off" />
                          </div>
                        </div>
                        <div class="col-md-4 col-sm-6" *ngIf="displayAUTHsearchvalues">
                          <div class="form-group">
                            <label class="fieldLabel ">Authors</label>
                            <input type="text" class="form-control" id="Authors" formControlName="Authors"
                              autocomplete="off" />
                          </div>
                        </div>
                        <div class="col-md-4 col-sm-6" *ngIf="displayPubDatasearchvalues">
                          <div class="form-group">
                            <label class="fieldLabel ">Publication Date</label>
                            <input type="text" class="form-control" id="PublicationDate"
                              formControlName="Published_Date" autocomplete="off" />
                          </div>
                        </div>

                        <div class="col-md-4 col-sm-6" *ngIf="displayPUBURLsearchvalues">
                          <div class="form-group">
                            <label class="fieldLabel">Publication URL</label>
                            <input type="text" class="form-control" id="PublicationURL"
                              formControlName="Publication_URL" autocomplete="off" />
                          </div>
                        </div>

                        <div class="col-md-4 col-sm-6" *ngIf="displayURLNamesearchvalues">
                          <div class="form-group">
                            <label class="fieldLabel">URL Display Name</label>
                            <input type="text" class="form-control" id="URLDisplayName"
                              formControlName="URL_Display_Name" autocomplete="off" />
                          </div>
                        </div>

                        <div class="col-md-12 d-flex" *ngIf="clearsearchenable">
                          <button type="button" class="btn btn-primary ml-auto mr-1" [disabled]="!enableSearch"
                            (click)="getPublicationsData(true)">Search</button>
                          <button type="button" class="btn btn-primary" [disabled]="!enableSearch"
                            (click)="clearSearch()">Clear</button>
                        </div>
                      </div>
                      <!-- -------------------------Sort By --------------------------------------- -->
                      <ng-container *ngIf="PubsTAList.length > 0">
                        <div class="col-md-12 d-flex  mt-3 border-top pt-2">
                          <select class="form-control ml-auto" id="Sortby" formControlName="SortBy"
                            style="width: 200px !important ;">
                            <option [defaultSelected]="" value="">-- Sort By --</option>
                            <option *ngFor="let area of sortList" value="{{area.Field_Code}}">
                              {{area.Field_Name}}</option>
                          </select>
                          <div class="pagination-rht d-flex justify-content-end">
                            <div class="pagination-btns">
                              <button class="px-2 imgbutton" [disabled]="!enableSortIcon()"
                                (click)="sortByOrder(true)"><i class="fas fa-caret-up"></i></button>
                              <button class="px-2 imgbutton" [disabled]="!enableSortIcon()"
                                (click)="sortByOrder(false)"><i class="fas fa-caret-down"></i></button>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                      <!-- ------------------------sortBy------------------------------------------------>
                    </form>
                  </div>
                </div>

                <div class="row pt-2">
                  <div class="col-md-12">
                    <div class="pb-0 pt-1">

                      <div class="accordion" id="accordionExample">
                        <div class="card">

                          <div class="row border-bottom pl-4 py-2"
                            *ngIf="page.pagedRecords && page.pagedRecords.length == 0">
                            <p>No results found</p>
                          </div>

                          <div class="row border-bottom py-2" *ngFor="let pub of page.pagedRecords; let i = index;">
                            <div class="col-md-12" *ngIf="displayTPAgridvalues">
                              <div class="card-toggle" data-toggle="collapse" attr.data-target="#collapseOne_{{i}}"
                                aria-expanded="false">
                                <div class="fs-18  text-primary">
                                  <span class="accicon">
                                    <i class="fas fa-angle-up rotate-icon px-1"></i>
                                    <strong>{{pub.Therapeutic_Area_Name}}</strong>
                                  </span>
                                </div>
                              </div>
                            </div>

                            <div class="col-md-12">
                              <div id="collapseOne_{{i}}" class="collapse show" data-parent="#accordionExample">
                                <div class="card-body p-0">

                                  <ng-container *ngFor="let prod of pub.ProductsList; let p = index">
                                    <div class="col-md-12 bt2" [ngClass]="(pub.ProductsList.length - 1 == p) ? '' : 'border-bottom'">
                                      <div class="card-body p-0">

                                        <div class="card-toggle" data-toggle="collapse"
                                          attr.data-target="#collapseTwo_{{i}}{{p}}" aria-expanded="false">
                                          <div class="col-md-12 px-0" *ngIf="displayProductgridvalues">
                                            <h1 class="title-sm pl-3 pt-2">
                                              <span class="accicon"><i
                                                  class="fas fa-angle-up rotate-icon px-1"></i></span>
                                              <strong>{{prod.Product_Name}} </strong>
                                            </h1>
                                          </div>
                                        </div>

                                        <div id="collapseTwo_{{i}}{{p}}" class="collapse show">
                                          <div class="card-body p-0">

                                            <div class="container-fluid">
                                              <ng-container *ngFor="let cat of prod.CategoriesList; let c = index;">
                                                <div class="py-0 mt-2">
                                                  <div class="row pt-2 pl-4 background dblock">

                                                    <ng-container class="col-md-12 px-0"
                                                      *ngIf="displayCategorygridvalues && cat.Category_Name != ''">
                                                      <div class="card-toggle" data-toggle="collapse"
                                                        attr.data-target="#collapseThree_{{i}}{{c}}"
                                                        aria-expanded="false">
                                                        <h1 class="title-sm pl-4">
                                                          <span class="accicon"><i
                                                              class="fas fa-angle-up rotate-icon px-1"></i></span>
                                                          <strong>{{cat.Category_Name}}</strong>
                                                        </h1>
                                                      </div>
                                                    </ng-container>

                                                    <div id="collapseThree_{{i}}{{c}}" class="collapse show">
                                                      <ng-container *ngFor="let pf of cat.PortalFilesList">
                                                        <div class=" col-md-12 fs-12 pl-4 mt-2"
                                                          *ngIf="displayPubTitlegridvalues">
                                                          <p class="text-dark">{{pf.Publication_Title}}</p>
                                                        </div>

                                                        <ng-container *ngIf="displayPubURLgridvalues">
                                                          <div class="col-md-12 pl-4 pt-2">
                                                            <a href="{{pf.Publication_URL}}" target="_blank"
                                                              class="text-transform">{{pf.Publication_URL}}
                                                            </a>
                                                          </div>
                                                        </ng-container>

                                                        <ng-container *ngIf="displayURLDisplayNamegridvalues">
                                                          <div class="col-md-12 pl-4 pt-2">
                                                            <a href="{{pf.Publication_URL}}" target="_blank"
                                                              class="text-transform">{{pf.URL_Display_Name != '' ?
                                                              pf.URL_Display_Name : pf.Publication_URL}}
                                                            </a>
                                                          </div>
                                                        </ng-container>

                                                        <div class="col-md-12">
                                                          <div class="row pt-2">
                                                            <div class="col-md-8 pl-4" *ngIf="displayAuthgridvalues">
                                                              <h1 class=" fs-12 font"
                                                                *ngIf="pf.Authors && pf.Authors != ''">
                                                                <span
                                                                  class="pr-1 author">Author(s):</span>{{pf.Authors}}
                                                              </h1>
                                                            </div>

                                                            <div class="col-md-4" *ngIf="displayPubDategridvalues">
                                                              <h1 class=" fs-12 px-2 font-display"
                                                                *ngIf="pf.Published_Date">
                                                                <span class="author pr-1">Published Date
                                                                  :</span>{{pf.Published_Date |
                                                                date: 'MMM dd, yyyy'}}
                                                              </h1>
                                                            </div>
                                                          </div>
                                                        </div>

                                                        <div class="col-md-12 pl-4 pt-2"
                                                          *ngIf="displayPubFileNamegridvalues">
                                                          <ng-container *ngFor="let file of pf.PubFiles">
                                                            <a href="javascript:void(0)" (click)="download(file)"
                                                              class="text-transform pl-4 fs-12">
                                                              {{file.Pubs_File_Name}}
                                                            </a>
                                                          </ng-container>
                                                        </div>

                                                        <div class="col-md-12 pl-4 pt-2"
                                                          *ngIf="displayFileNamegridvalues">
                                                          <ng-container *ngFor="let file of pf.PubFiles">
                                                            <a href="javascript:void(0)" (click)="download(file)"
                                                              class="text-transform pl-4 fs-12">
                                                              {{file.File_Display_Name != '' ? file.File_Display_Name :
                                                              file.Pubs_File_Name}}
                                                            </a>
                                                          </ng-container>
                                                        </div>

                                                      </ng-container>
                                                    </div>


                                                  </div>
                                                </div>
                                              </ng-container>
                                            </div>

                                          </div>
                                        </div>

                                      </div>
                                    </div>
                                  </ng-container>

                                </div>
                              </div>
                            </div>

                          </div>

                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <!-- --------------------------------------------------- -->
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4 col-lg-3">
      <div class="row">
        <app-promotional-cards></app-promotional-cards>
      </div>
    </div>
  </div>
</div>

<div class="pdf-img text-center" *ngIf="pdfDownloadURL" [style.display]="'none'">
  <iframe width="0" height="0" [src]="pdfDownloadURL" name="DownloadDocument" title="Download Document"></iframe>
</div>
